/// <amd-module name="Search/Shared/Components/ResultsInfo" />
export * from "./ResultsInfo/index";
